import axios from 'axios'

'use strict';

export default class SugarcoatSdk {

  constructor(apiBaseUrl, apiKey) {
    this.apiBaseUrl = apiBaseUrl;
    this.apiKey = apiKey;
    this.client = this.requestFactory();
  }

  trackProductAnalytic(productId) {
    return this.client.post('/analytics', {
      product_id: productId
    });
  }

  getBasketById(basketId) {
    return this.client.get('/baskets/' + basketId, {});
  }

  addProductToBasket(basketId, productId) {
    return this.client.put('/baskets/' + basketId + '/products/' + productId, {
      quantity: 1
    });
  }

  removeProductFromBasket(basketId, productId) {
    return this.client.delete('/baskets/' + basketId + '/products/' + productId, {
      quantity: 1
    });
  }

  getPageBySlug(slug) {
    const filters = [
      {
        property: 'slug',
        value: slug,
        operator: '='
      }
    ];
    return this.client.get('/pages', {
      params: {
        ...this.formatFilter(filters)
      }
    });
  }

  getPages(pagination, filters) {
    return this.client.get('/pages', {
      params: {
        ...pagination,
        ...this.formatFilter(filters)
      }
    });
  }

  getProductBySlug(slug) {
    const filters = [
      {
        property: 'slug',
        value: slug,
        operator: '='
      }
    ];
    return this.client.get('/products', {
      params: {
        ...this.formatFilter(filters)
      }
    });
  }

  getRecommendedProducts(productIds, type = ['all']) {
    return this.client.get('/products/recommendations', {
      params: {
        product_id: productIds,
        type: type
      }
    });
  }

  getProducts(pagination, filters) {
    return this.client.get('/products', {
      params: {
        ...pagination,
        ...this.formatFilter(filters)
      }
    });
  }

  getProductTypes(pagination, filters = []) {
    return this.client.get('/product-types', {
      params: {
        ...pagination,
        ...this.formatFilter(filters)
      }
    });
  }

  getCategories(pagination, filters, formatSorting) {
    return this.client.get('/categories', {
      params: {
        ...pagination,
        ...this.formatFilter(filters),
        ...this.formatSorting(formatSorting)
      }
    });
  }

  getCategoryOptions(pagination, filters) {
    return this.client.get('/category-options', {
      params: {
        ...pagination,
        ...this.formatFilter(filters)
      }
    });
  }

  formatFilter(filters) {
    let filterParams = {};

    if (filters.length > 0) {
      for (var i = 0; i < filters.length; i++) {
        filterParams['filters[' + i + '][property]'] = filters[i].property;
        filterParams['filters[' + i + '][value]'] = filters[i].value;
        filterParams['filters[' + i + '][operator]'] = filters[i].operator;
      }
    }

    return filterParams;
  }

  formatSorting(filters) {
    let filterParams = {};

    if (filters && filters.length > 0) {
      filterParams['sort[0][property]'] = filters.property;
      filterParams['sort[0][direction]'] = filters.direction;
    }

    return filterParams;
  }

  requestFactory() {
    return axios.create({
      baseURL: this.apiBaseUrl,
      timeout: 10000,
      headers: {
        "Authorization": this.apiKey
      }
    });
  }
}
